// Constantes de UI portadas desde app/app.js (líneas 1011-1093).

export const HINTS: Record<string, string> = {
  "Leads nuevos": "Contactos a los que se les creó una oportunidad en el periodo. Es la entrada de prospectos.",
  "Mediana 1ª respuesta": "Tiempo típico que tardó un HUMANO en dar la primera respuesta: la mitad de los leads se atendió más rápido que este valor. Se mide solo dentro del horario laboral de cada sucursal.",
  "Respondidos ≤ 1 h": "Porcentaje de leads que recibieron su primera respuesta humana en menos de 1 hora (tiempo hábil).",
  "Esperando humano ahora": "Leads cuyo último mensaje es del cliente y nadie del equipo les ha contestado (últimas 72 horas). Haz clic para ver la lista en Atender.",
  "Sin respuesta humana (activos)": "Leads del periodo que escribieron y NUNCA recibieron respuesta de un humano. El bot pudo haberlos atendido. No incluye a los abandonados por el filtro. Clic para ver la lista.",
  "Tasa de abandono": "Porcentaje de los leads del periodo que dejaron de contestar y el filtro marcó como abandonados. Clic para ver el detalle por sucursal y asesor.",
  "Ganadas / Perdidas": "Oportunidades cerradas como ganadas o perdidas en el periodo. Perdida = evaluó la propuesta y la rechazó (distinto de abandonado).",
  "Opt-outs (DND)": "Contactos que pidieron no ser contactados (No molestar). Acumulado histórico.",
  "Sesiones próximos 7 días": "Talleres/degustaciones agendados en los próximos 7 días.",
  "Inscritos próximos 7 días": "Personas registradas a las sesiones de los próximos 7 días.",
  "Promedio de inscritos": "Inscritos promedio por sesión en los últimos 30 días.",
  "Sin marcar asistencia": "Citas que ya pasaron pero siguen en \"confirmada\": falta marcar si asistieron o no. Si no se marca, no se puede medir la asistencia.",
  "Cancelaciones": "Citas canceladas en los últimos 30 días.",
  "1ᵃˢ respuestas": "Cantidad de leads donde este vendedor fue quien dio la primera respuesta humana.",
  "Mediana 1ª resp.": "Tiempo típico de su primera respuesta (mitad de sus leads más rápido). Solo horario laboral. Meta: ≤ 5 min.",
  "% ≤ 5 min": "De sus primeras respuestas, % dadas en 5 minutos o menos (tiempo hábil). La meta del equipo.",
  "% ≤ 10 min": "De sus primeras respuestas, % dadas en 10 minutos o menos (tiempo hábil).",
  "Contactos": "Clientes distintos con los que este vendedor cruzó mensajes en el periodo.",
  "Ganadas": "Oportunidades marcadas como ganadas asignadas a este vendedor.",
  "% fichas completas": "De sus leads del periodo, % con la ficha bien llenada: nombre y apellido, sin emojis, con negocio y teléfono. Meta: verde ≥80%.",
  "Alertas calidad 14d": "Conversaciones suyas que la IA señaló en los últimos 14 días (cliente molesto, mala atención o riesgo). Ver detalle en la pestaña Calidad.",
  "Leads del periodo": "Oportunidades creadas dentro del rango de fechas elegido.",
  "Abandonados": "Leads que dejaron de contestar y el filtro marcó como abandonados.",
  "Perdidos": "Leads que sí evaluaron la propuesta pero la rechazaron (con motivo de pérdida).",
  "Activos": "Leads con oportunidad abierta que siguen en juego.",
  "Ganados": "Leads convertidos en venta.",
};
export const TH_HINTS: Record<string, string> = {
  "1ᵃˢ resp.": "Leads donde este vendedor dio la primera respuesta humana",
  "Mediana": "Tiempo típico de 1ª respuesta (horario laboral). Meta ≤ 5 min: verde ≤5, ámbar ≤10, rojo >10",
  "% ≤5 min": "% de sus primeras respuestas dadas en ≤5 min hábiles (la meta)",
  "% ≤10 min": "% de sus primeras respuestas dadas en ≤10 min hábiles",
  "% ≤1 h": "% de sus primeras respuestas dadas en ≤1 hora hábil",
  "Msgs": "Mensajes enviados por este vendedor en el periodo",
  "Contactos": "Clientes distintos que atendió en el periodo",
  "Asignados": "Oportunidades del periodo asignadas a este vendedor",
  "Ganadas": "Oportunidades ganadas de las asignadas en el periodo",
  "Perdidas": "Oportunidades perdidas o abandonadas de las asignadas en el periodo",
  "% Ganadas": "Ganadas ÷ (Ganadas + Perdidas) — de las oportunidades ya decididas, cuántas se cerraron. No cuenta las que siguen abiertas.",
  "% perd. c/motivo": "De sus perdidas, % con motivo de pérdida capturado (higiene del CRM)",
  "Estancadas 7d": "Oportunidades abiertas sin cambio de etapa en 7+ días",
  "Notas": "Notas escritas en el CRM en el periodo",
  "% fichas": "% de sus leads del periodo con ficha completa (nombre y apellido, sin emojis, negocio y teléfono)",
  "Alertas cal.": "Alertas de calidad de la IA en sus conversaciones (últimos 14 días)",
  "Dueño": "Asesor asignado al contacto en GHL",
  "Abandonado": "Fecha en que cayó a la etapa de abandono",
  "Escribió": "Fecha del primer mensaje del cliente",
  "Días": "Días transcurridos desde que escribió sin recibir respuesta humana",
};

// icono por tarjeta (solo cosmético) — si una etiqueta no está aquí, la tarjeta se ve igual pero sin el círculo de icono
export const TILE_ICONS: Record<string, string> = {
  "Leads nuevos": "i-userplus",
  "Mediana 1ª respuesta": "i-clock",
  "Respondidos ≤ 1 h": "i-clock",
  "Esperando humano ahora": "i-headset",
  "Sin respuesta humana (activos)": "i-chat",
  "Tasa de abandono": "i-alert",
  "Ganadas / Perdidas": "i-check",
  "Opt-outs (DND)": "i-userx",
};
export const TILE_URGENTE = new Set<string>(["Esperando humano ahora", "Tasa de abandono"]);

// delta = { pct, mejor } donde mejor = true/false/null (null = no evaluamos si "mejorar" es subir o bajar)
